import {
  Box,
  HStack,
  IconButton,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FormInputControl, FormSingleCheckbox } from "../../components/forms";
import {
  FormSelectControl,
  ISelectOption,
} from "../../components/forms/SelectControl";
import { MaterialIcon } from "../../components/shared/MaterialIcon";

interface IProps {
  name: string;
  onRemove: () => void;
  columns: ISelectOption[];
}

export const FormQuerySelectPill = ({ name, onRemove, columns }: IProps) => {
  const handleOnRemoveSelect = () => {
    onRemove();
  };

  return (
    <HStack spacing={6} px={4} py={3} borderWidth={1} bg="bg.high">
      <Box>
        <MaterialIcon
          color="text.softer"
          name="category"
          variant="outline"
          fontSize="1.25rem"
        />
      </Box>
      <Stack flex={1}>
        <HStack>
          <FormSelectControl
            name={`${name}.columnName`}
            placeholder=""
            options={columns}
            formControlProps={{
              maxW: "16rem",
            }}
            bg="bg.main"
          ></FormSelectControl>

          <Text>as</Text>

          <FormInputControl
            name={`${name}.asValue`}
            placeholder=""
            formControlProps={{
              maxW: "22rem",
            }}
            bg="bg.main"
          />

          <Box>
            <Tooltip label="Remove Select">
              <IconButton
                onClick={handleOnRemoveSelect}
                icon={
                  <MaterialIcon
                    color="text.soft"
                    name="delete"
                    fontSize="1.25rem"
                    variant="outline"
                  />
                }
                aria-label="remove filters columns"
              ></IconButton>
            </Tooltip>
          </Box>
        </HStack>
        <FormSingleCheckbox name={`${name}.isDistinct`}>
          <Text>Distinct</Text>
        </FormSingleCheckbox>
      </Stack>
    </HStack>
  );
};
